export function formatNumberWithPunctuation(value?: number, defaaultEmptyString = ''): string {
  if (value === 0) return '0'

  if (!value) return defaaultEmptyString

  return value.toLocaleString('pt-BR')

  return `${value || 0}`
  //! A biblioteca Apex entende de forma errada os números convertidos, fazendo o gráfico ficar apresentando informações erradas

  // const { format } = new Intl.NumberFormat('pt-BR', {
  //   style: 'decimal',
  // })

  // return format(value)
}
